import React, { useEffect, useState } from "react";
import axiosInstance from "../api/axiosInstance";
import { Spin } from "antd";
import { useCity } from "../context/CityContext";
import { useNavigate } from "react-router-dom";

const SpatialToursSection = () => {
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(false);

  const { selectedCity } = useCity();
  const navigate = useNavigate();

  // ==========================================
  // FETCH CITY RELATED TOURS
  // ==========================================
  useEffect(() => {
    if (selectedCity?.slug) {
      fetchTours();
    } else {
      setTours([]);
    }
  }, [selectedCity]);

  const fetchTours = async () => {
    try {
      setLoading(true);

      const res = await axiosInstance.get("/product-details", {
        params: {
          // CITY FILTER
          "filters[city][slug][$eq]": selectedCity.slug,

          // Fields
          "fields[0]": "title",
          "fields[1]": "slug",

          // Sub product for URL
          "populate[sub_product][fields][0]": "slug",

          // City
          "populate[city][fields][0]": "name",
          "populate[city][fields][1]": "slug",

          // Get all tours
          "pagination[page]": 1,
          "pagination[pageSize]": 100,
        },
      });

      const data = res.data?.data || [];

      setTours(data);
 
    } catch (error) {
      console.error("City Tours API Error:", error);
      setTours([]);
    } finally {
      setLoading(false);
    }
  };

  // ==========================================
  // LOADING
  // ==========================================
  if (loading) {
    return (
      <div className="flex justify-center py-10">
        <Spin size="large" tip="Loading tours..." />
      </div>
    );
  }

  // ==========================================
  // CITY NAME
  // ==========================================
  const cityName =
    selectedCity?.name ||
    "Dubai";

  return (
    <div className="">
      
      {/* TITLE */}
      <h2 className="text-2xl font-normal text-black mb-4">
        Best Selling {cityName} Tours
      </h2>

      {/* TOURS */}
      {tours.length > 0 ? (
        <div className="text-sm font-medium leading-relaxed">
          {tours.map((tour, index) => {

            const title =
              tour.title ||
              "Untitled Tour";

            const subSlug =
              tour.sub_product?.slug ||
              "activity";

            const detailSlug =
              tour.slug ||
              "details";

            return (
              <React.Fragment key={tour.id}>

                <a
                  href={`/${subSlug}/${detailSlug}`}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(`/${subSlug}/${detailSlug}`);
                  }}
                  className="text-primary hover:underline cursor-pointer"
                >
                  {title}
                </a>

                {index < tours.length - 1 && (
                  <span className="text-black">
                    {" | "}
                  </span>
                )}

              </React.Fragment>
            );
          })}
        </div>
      ) : (
        <p className="text-gray-500">
          No tours available in {cityName}.
        </p>
      )}

    </div>
  );
};

export default SpatialToursSection;